import {SoopSkeleton} from '@soop-ui/soop-ui';
import styles from './Skeleton.module.scss';
import clsx from 'clsx';
import useGlobalUIStore from '@/stores';

const Skeleton = () => {
  const {isLnbOpened} = useGlobalUIStore();

  return isLnbOpened ? <DefaultSkeleton /> : <MiniSkeleton />;
};

const DefaultSkeleton = () => {
  return (
    <div className={styles.ChannelServiceLeftMenu}>
      <div className={styles.innerLnb}>
        <div className={styles.profile}>
          <SoopSkeleton
            width={80}
            height={80}
            animated
            className={styles.avatar}
          />
          <SoopSkeleton
            width={60}
            height={24}
            animated
            className={styles.name}
          />
          <div className={styles.badges}>
            <SoopSkeleton width={44} height={18} animated />
            <SoopSkeleton width={44} height={18} animated />
          </div>
          <SoopSkeleton width={200} height={32} animated />
        </div>

        <div className={clsx(styles.fanList)}>
          <div className={styles.title}>
            <SoopSkeleton width={60} height={19} animated />
          </div>
          {Array.from({length: 3}, (_, index) => (
            <div className={clsx(styles.list)} key={index}>
              <SoopSkeleton width={24} height={24} animated />
              <SoopSkeleton width={100} height={19} animated />
            </div>
          ))}
          <div className={clsx(styles.title, styles.last)}>
            <SoopSkeleton width={60} height={19} animated />
          </div>
          {Array.from({length: 3}, (_, index) => (
            <div className={clsx(styles.list)} key={index}>
              <SoopSkeleton width={24} height={24} animated />
              <SoopSkeleton width={100} height={19} animated />
            </div>
          ))}
        </div>

        <div className={styles.bottomBtn}>
          <SoopSkeleton width={140} height={32} animated />
        </div>

        <div className={clsx(styles.fanList)}>
          {Array.from({length: 6}, (_, index) => (
            <div className={clsx(styles.list)} key={index}>
              <SoopSkeleton width={24} height={24} animated />
              <SoopSkeleton width={100} height={19} animated />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const MiniSkeleton = () => {
  return (
    <div className={clsx(styles.ChannelServiceLeftMenu, styles.mini)}>
      <div className={styles.innerLnb}>
        {Array.from({length: 6}, (_, index) => (
          <div className={clsx(styles.list, styles.mini)} key={index}>
            <SoopSkeleton width={24} height={24} animated />
            <SoopSkeleton width={30} height={10} animated />
          </div>
        ))}

        {Array.from({length: 2}, (_, index) => (
          <div className={clsx(styles.fanList)} key={index}>
            <div className={clsx(styles.list, styles.mini)} key={index}>
              <SoopSkeleton width={24} height={24} animated />
              <SoopSkeleton width={30} height={10} animated />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skeleton;
